var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "14",
        viewBox: "-1 -1 16 14"
      }
    },
    [
      _c(
        "g",
        { attrs: { stroke: "#fff", "stroke-width": "2", fill: "transparent" } },
        [_c("path", { attrs: { d: "M0,6 l14,0 m-6,-6 l6,6 l-6,6" } })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }